import type { ComponentProps } from "react";

import { cn } from "@/lib/utils/cn";

export function Card({ className, ...props }: ComponentProps<"div">) {
    return <div className={cn("rounded-lg border bg-card text-card-foreground shadow-sm", className)} {...props} />;
}

export function CardHeader({ className, ...props }: ComponentProps<"div">) {
    return <div className={cn("flex items-center justify-between gap-2 border-b px-4 py-2", className)} {...props} />;
}

export function CardContent({ className, ...props }: ComponentProps<"div">) {
    return <div className={cn("px-4 py-3", className)} {...props} />;
}
